import { useQuery, skipToken } from "@tanstack/react-query";
import { SystemInputs } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const useInput = (inputId) => useQuery({
  queryKey: ["inputs", inputId],
  queryFn: inputId ? () => defaultOnError(SystemInputs.get(inputId), "Loading input failed with status", "Could not load input") : skipToken
});
export default useInput;
